﻿export const getUpdatedProjectTeamRoles = (formFieldValues, projectRoles) => {
  if (typeof formFieldValues !== "object") return;

  const fields = Object.keys(formFieldValues).map(
    (key) => formFieldValues[key]
  );

  const newRoles = fields.filter((field) => field.isNewRole);
  const roleIdsToDelete = fields
    .filter((field) => field.isDeleted)
    .map(({ id }) => id);

  const filteredProjectRoles = (projectRoles ?? []).filter(
    (role) => role.regionId && !roleIdsToDelete.includes(role.id)
  );

  return [...filteredProjectRoles, ...newRoles].map((role) => {
    if (!formFieldValues[role.id]) return { ...role };

    const formHasCoreTeamValue =
      formFieldValues[role.id].isCoreTeam === true ||
      formFieldValues[role.id].isCoreTeam === false;

    return {
      ...role,
      isCoreTeam: formHasCoreTeamValue
        ? formFieldValues[role.id].isCoreTeam
        : role.isCoreTeam,
      assignedUsers: formFieldValues[role.id].assignedUsers || [],
    };
  });
};
